import BeaconSignInContainer from './BeaconSignInContainer';

export default BeaconSignInContainer;
